import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Heart, Facebook } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "../lib/api";
import { services } from "../data/services";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 bg-secondary text-secondary-foreground"
    >
      <div className="max-w-7xl mx-auto container-px py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-5 text-foreground/70 max-w-md text-base leading-relaxed">
            PeerWave is a small NDIS provider on the Fraser Coast.
            We run supported classes, social groups and daily-living help — the
            kind of support that feels less like paperwork and more like friendship.
          </p>
          <p className="mt-5 text-xs uppercase tracking-[0.22em] text-muted-foreground">
            Proudly independent &middot; Person-first &middot; Fraser Coast, QLD
          </p>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold mb-4">Services</h4>
          <ul className="space-y-2">
            {services.map((s) => (
              <li key={s.id}>
                <Link
                  to={`/services/${s.id}`}
                  data-testid={`footer-service-${s.id}`}
                  className="text-sm text-foreground/70 hover:text-primary transition"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={CONTACT.phoneDial}
                data-testid="footer-phone"
                className="inline-flex items-center gap-2.5 text-foreground/80 hover:text-primary transition"
              >
                <Phone className="h-4 w-4 text-primary" />
                {CONTACT.phone}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.emailLink}
                data-testid="footer-email"
                className="inline-flex items-center gap-2.5 text-foreground/80 hover:text-primary transition break-all"
              >
                <Mail className="h-4 w-4 text-primary" />
                {CONTACT.email}
              </a>
            </li>
            <li className="inline-flex items-center gap-2.5 text-foreground/80">
              <MapPin className="h-4 w-4 text-primary" />
              {CONTACT.location}
            </li>
            <li>
              <a
                href={CONTACT.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="inline-flex items-center gap-2.5 text-foreground/80 hover:text-primary transition"
              >
                <Facebook className="h-4 w-4 text-primary" />
                {CONTACT.facebookLabel}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border/70">
        <div className="max-w-7xl mx-auto container-px py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} PeerWave. All rights reserved.</span>
          <span className="inline-flex items-center gap-1.5">
            Built with <Heart className="h-3.5 w-3.5 text-primary fill-primary" /> for the Fraser Coast community
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
